<template>
    <div class="story-maker-sticker-menu-link">
        <div class="header-menu">
            <p>{{ $t('dash.post-creator.story.link-title') }}</p>
        </div>
        <div class="content">
            
            <div class="form">
                <div class="container-input">
                    <div class="input input-link">
                        <i class="fa-regular fa-link"></i>
                        <input :placeholder="$t('dash.post-creator.story.url-placeholder')" v-model="models.link">
                    </div>
                    <div class="url-length-info">
                        <p class="url-length-warning" v-if="isOverLimit">{{ $t('dash.post-creator.story.link-url-too-long') }}</p>
                        <p class="url-length-info-bitly" v-else-if="hasBitlyToken && models.link.length > 245">{{ $t('dash.post-creator.story.link-url-bitly') }}</p>
                        <span class="url-length-count" :class="{ 'at-limit': isOverLimit }">{{ models.link.length }}/245</span>
                    </div>
                    <p class="error">{{ error }}</p>
                </div>
                
                <p v-if="!showEditText" @click="toggleDisplayAddText" class="add-text"><i class="fa-solid fa-plus"></i> {{ $t('dash.post-creator.story.link-add-text') }}</p>
                <p v-else="" @click="toggleDisplayAddText" class="add-text">{{ $t('dash.post-creator.story.link-remove-text') }}</p>
                
                <div v-if="showEditText" class="container-input">
                    <div class="input input-text">
                        <input :placeholder="$t('dash.post-creator.story.link-sticker-text-placeholder')" v-model="models.text">
                    </div>
                </div>

            </div>

            <div class="button" :class="{ disable: isOverLimit }" @click="finish">
                {{ $t('dash.post-creator.story.add-button') }}
            </div>
        </div>
        
    </div>
</template>


<script>
const { VUE_APP_API_HOST } = process.env

export default {
    data() {
        return {
            models: {
                link : '',
                text: '',
            },
            showEditText : false,
            error : '',
            hasBitlyToken: false,
        }
    },

    computed: {
        isOverLimit() {
            return this.models.link.length > 245 && !this.hasBitlyToken;
        }
    },

    async mounted() {
        try {
            const user = JSON.parse(localStorage.user);
            const res = await this.$http.get(`${VUE_APP_API_HOST}/accounts/${user.account}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            this.hasBitlyToken = !!(res.body && res.body.account && res.body.account.bitly_token);
        } catch(e) {
            // silently fail — limit stays enforced
        }
    },

    methods: {
        finish() {
            if (this.isOverLimit) return
            this.error = ''
            this.models.link = this.models.link.trim();
            console.log('validURL', this.models.link, this.validURL(this.models.link))
            if (!this.validURL(this.models.link)){
                this.error = 'adresse invalide'
                return
            }
           
            this.$emit('addSticker','link', {
                data: {
                    ...this.models,
                    styleVariant: 1
                }
            })
        },

        validURL(str) {
            if(str == '') return true
            try {
                return Boolean(new URL(str)); 
            }
            catch(e){ 
                return false; 
            }
        },

        toggleDisplayAddText() {

            this.showEditText = !this.showEditText
            this.models.text = ''
        }
    },
}
</script>

<style lang="scss" scoped>

</style>